import styled from "styled-components";

export const BadgePill = styled.span`
  padding: 4px 8px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 700;
  font-family: var(--font-sans);
  white-space: nowrap;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  ${({ $border }) => $border && `border: ${$border};`}
`;

export const DeltaPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 7px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 700;
  font-family: var(--font-mono);
  background: ${({ $up }) => ($up ? "#dcfce7" : "#fee2e2")};
  color: ${({ $up }) => ($up ? "#16a34a" : "#dc2626")};
`;
